import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
// import { HttpClient } from '@angular/common/http'; // <-- No longer needed
import { FeatureFlagService } from '../src/betauser-flag.service';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '../src/app/core/auth.service'; // <-- IMPORT AuthService
import { UserService } from '../src/app/core/user.service'; // <-- IMPORT UserService

export const betaAccessGuard = (route: any) => {
  const router = inject(Router);
  // const http = inject(HttpClient); // <-- REMOVED
  const authService = inject(AuthService); // <-- ADDED
  const userService = inject(UserService); // <-- ADDED
  const featureFlagService = inject(FeatureFlagService);
  const msalService = inject(MsalService);

  const currentUser = msalService.instance.getAllAccounts()[0]?.username;
  const targetPath = route.routeConfig?.path;
  
const isSearchMode = sessionStorage.getItem('athenaSearchMode') === 'true';

console.log('🛡️ Guard - Search mode:', isSearchMode);


  console.log('🛡️ Guard - Target path:', targetPath);
  console.log('🛡️ Guard - Current user:', currentUser);
  
if (isSearchMode && targetPath === 'territorydashboard') {
  console.log('🚫 BLOCKED: Search mode active → cannot open territorydashboard');

  return of(false);   // ✅ IMPORTANT: STOP EVERYTHING HERE
}


  return featureFlagService.getConfig().pipe(
    switchMap(config => {
      console.log('🛡️ Guard - Config:', config);
      console.log('🛡️ Guard - betaUserEnabled:', config?.betaUserEnabled);

      // If beta is NOT enabled
      if (config?.betaUserEnabled !== true) {
        console.log('🛡️ Guard - Beta disabled');

        
        
        // Allow territoryView if user has territories
        if (targetPath === 'territoryView') {
          const hasTerritories = userService.currentUser?.territories?.length > 0;
          console.log('🛡️ Guard - territoryView requested, user has territories:', hasTerritories);
          if (hasTerritories) {
            console.log('🛡️ Guard - Allowing access to territoryView (user has territories)');
            return of(true);
          } else {
            console.log('🛡️ Guard - Blocking territoryView (user has no territories), redirecting to nonTerritoryDashboard');
            router.navigate(['/nonTerritoryDashboard']);
            return of(false);
          }
        }
        
        // Allow territorydashboard if user has territories
        if (targetPath === 'territorydashboard') {
          const hasTerritories = userService.currentUser?.territories?.length > 0;
          console.log('🛡️ Guard - territorydashboard requested, user has territories:', hasTerritories);
          if (hasTerritories) {
            console.log('🛡️ Guard - Allowing access to territorydashboard (user has territories)');
            return of(true);
          } else {
            console.log('🛡️ Guard - Blocking territorydashboard (user has no territories), redirecting to nonTerritoryDashboard');
            router.navigate(['/nonTerritoryDashboard']);
            return of(false);
          }
        }
        
        // Allow nonTerritoryDashboard
        if (targetPath === 'nonTerritoryDashboard') {
          console.log('🛡️ Guard - Allowing access to nonTerritoryDashboard');
          return of(true);
        }
        
        // Block all other paths
        console.log('🛡️ Guard - Blocking access to', targetPath);
        router.navigate(['/nonTerritoryDashboard']);
        return of(false);
      }

      // Beta IS enabled - check beta user list
      console.log('🛡️ Guard - Beta enabled, checking user against DB');

      // --- THIS IS THE FIX ---
      // Call our AuthService instead of the static JSON file.
      return authService.checkBetaUser(currentUser).pipe(
        map(betaStatus => { // The response is now { isBetaUser: boolean }
          console.log('🛡️ Guard - Beta user status from DB:', betaStatus);
          
          // Get the boolean value from the response
          const emailExists = betaStatus.isBetaUser;
          // --- END OF FIX ---

          console.log('🛡️ Guard - Email in beta list:', emailExists);
          console.log('🛡️ Guard - Target path:', targetPath);

          // Email IN beta list
          if (emailExists) {
            if (targetPath === 'nonTerritoryDashboard' || targetPath === 'territorydashboard') {
              console.log('✅ Guard - Beta user accessing', targetPath, '- ALLOW');
              return true;
            } else if (targetPath === 'orderStatus') {
              console.log('❌ Guard - Beta user trying orderStatus - REDIRECT to nonTerritoryDashboard');
              router.navigate(['/nonTerritoryDashboard']);
              return false;
            }
          }

          // Email NOT in beta list
          if (!emailExists) {
            // Users with NO territories should access nonTerritoryDashboard
            const hasTerritories = userService.currentUser?.territories?.length > 0;
            
            if (targetPath === 'nonTerritoryDashboard') {
              if (!hasTerritories) {
                console.log('✅ Guard - Non-beta user with NO territories accessing nonTerritoryDashboard - ALLOW');
                return true;
              } else {
                console.log('❌ Guard - Non-beta user with territories trying nonTerritoryDashboard - REDIRECT to orderStatus');
                router.navigate(['/orderStatus']);
                return false;
              }
            } else if (targetPath === 'orderStatus') {
              if (hasTerritories) {
                console.log('✅ Guard - Non-beta user with territories accessing orderStatus - ALLOW');
                return true;
              } else {
                console.log('❌ Guard - Non-beta user with NO territories trying orderStatus - REDIRECT to nonTerritoryDashboard');
                router.navigate(['/nonTerritoryDashboard']);
                return false;
              }
            } else if (targetPath === 'territorydashboard') {
              console.log('❌ Guard - Non-beta user trying territorydashboard - REDIRECT to appropriate route');
              const redirectTo = hasTerritories ? '/orderStatus' : '/nonTerritoryDashboard';
              router.navigate([redirectTo]);
              return false;
            }
          }

          // Default fallback
          console.log('⚠️ Guard - Unexpected path, defaulting to true');
          return true;
        }),
        catchError(error => {
          console.error('❌ Guard - Error checking beta status:', error);
          // On error, allow if accessing nonTerritoryDashboard
          if (targetPath === 'nonTerritoryDashboard') {
            return of(true);
          }
          router.navigate(['/nonTerritoryDashboard']);
          return of(false);
        })
      );
    }),
    catchError(error => {
      console.error('❌ Guard - Error loading config:', error);
      // On error, allow access to nonTerritoryDashboard
      if (targetPath === 'nonTerritoryDashboard') {
        return of(true);
      }
      router.navigate(['/nonTerritoryDashboard']);
      return of(false);
    })
  );
};

